import React, { CSSProperties } from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'

// Image with Mobile-Desktop-Switch
export interface LinkProps {
  url?: string
  children?: string | React.ReactNode
  hideIcon?: boolean
  target?: '_blank' | 'self' | '_parent' | '_top' | [string, string]
  className?: string
  css?: CSSProperties
}

export const Link = ({
  url = '',
  children,
  hideIcon,
  target = ['_parent', '_blank'],
  className,
  css = {}
}: LinkProps) => {
  css.whiteSpace = 'nowrap'
  var openIn: string
  if (typeof target === 'object') {
    if (browserCheck.isMobile) {
      openIn = target[0]
    } else {
      openIn = target[1]
    }
  } else {
    openIn = target
  }
  return (
    <>
      <a href={url} target={openIn} className={className} style={css}>
        {!hideIcon && <i className='icon external alternate' />}
        {children}
      </a>
    </>
  )
}
